/*!
 * MHMagicWeeks · MagicHolz · MagicWeeks 2026
 * ------------------------------------------------------------------
 * Eine Datei fuer alle zeit- und warenkorbabhaengigen Bausteine der
 * Kampagne: Phasen (Landingpage, Kampagnen-Leiste, Hub-Hinweis),
 * Countdown, Geschenk-Fortschritt (Warenkorb, Bestaetigungs-Modal,
 * Produktseite).
 *
 * Grundsaetze
 * - Alle Texte stehen serverseitig im HTML (Weglot). Dieses Skript blendet
 *   nur ein/aus und setzt Zahlen (Betraege, Countdown).
 * - Zeitpunkte sind deutsche Zeit. Mit Versatz (+01:00) werden sie exakt
 *   gelesen, ohne Versatz als Ortszeit Europe/Berlin (Sommer-/Winterzeit
 *   nach EU-Regel, unabhaengig von der Zeitzone des Besuchers). Gelesen
 *   werden 2026-10-29T00:00:00+01:00, 2026-10-29 00:00 und 29.10.2026 00:00.
 * - Uhr: Es gilt die Uhr des Besuchers (Seiten kommen aus dem Cache). Steht
 *   sie VOR der Serverzeit, mit der die Seite gerendert wurde, wird um die
 *   Differenz korrigiert: Uhr zurueckstellen zeigt keine fruehere Phase.
 * - Warenkorbdaten kommen aus den Theme-Events cart:updated / cart:refresh
 *   (Focal sendet beim Seitenaufruf ohnehin /cart.js). Ein eigener Abruf
 *   passiert nur, wenn nach 3 Sekunden kein Event kam oder ein Event ohne
 *   Warenkorb eintrifft, und nur solange die Aktion laeuft.
 * - Kein jQuery, keine externen Skripte, ein globaler Name: MHMagicWeeks.
 *
 * Geschenk per Auswahl (dritte Fassung, 08.10.2026): Die App "EG Auto Add to Cart"
 * legt das Geschenk nicht von selbst ein, sondern zeigt ein Pop-up zur Auswahl.
 * Der Button "Geschenk auswaehlen" im Warenkorb-Balken (data-mhmw-wahl) oeffnet
 * das Pop-up der App, wenn es gerade im Markup steht (#aca-modal), sonst klickt er den
 * Erinnerungs-Banner der App an (.aca-reminder-banner-container), dann oeffnet die App
 * ihr Pop-up erneut. Die App merkt sich "Schliessen" (localStorage EG_DISMISSED_POPUP_RULES)
 * und zeigt das Pop-up danach nur noch ueber diesen Banner.
 * Neu 13.10.2026: Fehlt beides, legt der Button das Geschenk selbst ein (/cart/add.js mit
 * _Gifted = Regelname aus dem Produkt-Metafeld custom.eg_regel, dazu _q=geschenk-button).
 * Den Preis 0 € setzt weiter der Rabatt der App; er prueft Schwelle und Menge auf dem
 * Server (getestet 13.10.: unter 99 € kein Rabatt, zweites Stueck kein Rabatt, ohne
 * oder mit falschem Regelnamen kein Rabatt). Kostet die Zeile danach doch etwas,
 * nimmt das Skript sie wieder heraus. Ohne Regelname: Banner, sonst Neuladen (alt).
 * Aufraeumen: App-Geschenkzeilen (_Gifted), die etwas kosten (Schwelle unterschritten,
 * zweites Stueck, Regel abgelaufen), entfernt das Skript automatisch, damit niemand
 * ein "Geschenk" bezahlt (Funktion raeumeAuf).
 *
 * Test: ?mw_now=2026-11-05T10:00 wirkt NUR im Theme-Editor und in der
 * Vorschau eines nicht veroeffentlichten Themes (siehe testErlaubt). Im
 * veroeffentlichten Theme gibt es keinen Testmodus, auch nicht ueber einen
 * gespeicherten Stand. ?mw_cart=8990 simuliert einen Warenwert in Cent,
 * ?mw_gift=1 dazu eine Geschenk-Zeile im Warenkorb. ?mw_now=off beendet den Test.
 * Stand 13.10.2026 abends (Pop-up der App zuerst: Banner, dann selbst einlegen; Aufraeumen teurer Geschenkzeilen)
 * 2026.7 (14.10.2026 abends, Ruhige Journey v3.1, Agent cart2): Lehnt der Server das selbst eingelegte Geschenk ab
 * (Zeile bleibt nicht bei 0 EUR, z. B. weil ein anderer Rabatt wie "VVK Kalender: Farben -50 %" nicht mit
 * Produktrabatten kombinierbar ist), steht unter dem Knopf eine verstaendliche Zeile statt "Gerade nicht moeglich":
 * "Geht leider nicht zusammen mit „<Titel>“." (Titel aus /cart.js: items[].discounts / line_level_discount_allocations,
 * cart_level_discount_applications; ohne Geschenk-Zeilen und ohne den Regelnamen), sonst
 * "Hat gerade nicht geklappt. Bitte lade die Seite neu." (fin2 14.10.: ohne Gedankenstrich, Marken-Regel; Anfuehrungs-
 * zeichen als Zeichen statt \u-Escape, damit die Pruefsumme im Theme gleich bleibt). Der Knopf behaelt seinen Text, bleibt deaktiviert
 * (data-mhmw-gesperrt, zeigeStand schaltet ihn nicht wieder frei), die Warenkorbseite laedt fuer das Aufraeumen
 * nicht neu (sonst waere die Zeile sofort weg).
 * 2026.8 (20.10.2026, Stufe 2 mit eigenem Knopf, Geschenke als Shopify-Rabatte): Ab Stufe 2 zeigt die Karte im Warenkorb
 * und im Pop-up die eine Weltkarte aus dem Theme-Editor mit Knopf "Gratis dazulegen" (data-mhmw-wahl2, Varianten-ID s2v,
 * Regel s2r aus snippets/mh-mw-konfig). Geschenk-Zeilen werden je Stufe gezaehlt (Weltkarte = Stufe 2, Rest = Stufe 1),
 * "d" heisst bei Stufe 1 und 2 jetzt "Geschenk der Stufe 1 liegt im Warenkorb", die Weltkarte hat einen eigenen Zustand
 * (zustand2: o/b/d). Geschenk-Produkte zaehlen auch bezahlt nicht zur Schwelle, wie die Basis-Kollektionen der Rabatte:
 * Stufe 1 ohne die Produkte der Geschenk-Plaetze ab Beginn ihres Zeitfensters (gp), Stufe 2 zusaetzlich ohne die
 * Weltkarten (s2a). Ausverkauftes Geschenk (HTTP 422 beim Einlegen) laedt die Seite nicht mehr neu, sondern zeigt die
 * Meldung unter dem Knopf.
 */
(function (win) {
  'use strict';

  var doc = win && win.document ? win.document : null;

  if (win && win.MHMagicWeeks && win.MHMagicWeeks.__geladen) {
    if (typeof module === 'object' && module.exports) { module.exports = win.MHMagicWeeks; }
    return;
  }

  /* ================================================================
     1 · Zeit
     ================================================================ */

  /* Letzter Sonntag eines Monats um 01:00 UTC (EU-Umstellungszeitpunkt). */
  function letzterSonntagUTC(jahr, monat) {
    var d = new Date(Date.UTC(jahr, monat + 1, 0, 1, 0, 0));
    d.setUTCDate(d.getUTCDate() - d.getUTCDay());
    return d.getTime();
  }

  /* Versatz Europe/Berlin zu UTC in Minuten: 120 in der Sommerzeit, sonst 60. */
  function berlinVersatzMin(utcMs) {
    var jahr = new Date(utcMs).getUTCFullYear();
    return (utcMs >= letzterSonntagUTC(jahr, 2) && utcMs < letzterSonntagUTC(jahr, 9)) ? 120 : 60;
  }

  var ZEIT_RE = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2})(?:[.,]\d+)?)?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i;
  /* deutsche Schreibweise 29.10.2026 oder 29.10.2026 14:35[:00], immer deutsche Ortszeit */
  var ZEIT_DE_RE = /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:,?\s+(\d{1,2})[:.](\d{2})(?::(\d{2}))?(?:\s*Uhr)?)?$/i;

  /* "2026-10-29T00:00:00+01:00", "2026-10-29T00:00" oder "29.10.2026 00:00" (= deutsche Zeit) -> Millisekunden, sonst NaN. */
  function zeit(wert) {
    if (typeof wert === 'number') { return wert; }
    if (!wert) { return NaN; }
    var text = String(wert).replace(/^\s+|\s+$/g, '');
    var m = ZEIT_RE.exec(text);
    if (!m) {
      var d = ZEIT_DE_RE.exec(text);
      if (!d) { return NaN; }
      m = [text, d[3], d[2], d[1], d[4], d[5], d[6], undefined];
    }
    var mo = +m[2] - 1, tag = +m[3], std = +(m[4] || 0), min = +(m[5] || 0), sek = +(m[6] || 0);
    if (mo < 0 || mo > 11 || tag < 1 || tag > 31 || std > 24 || min > 59 || sek > 59) { return NaN; }
    var wand = Date.UTC(+m[1], mo, tag, std, min, sek);
    if (m[7]) {
      if (/^z$/i.test(m[7])) { return wand; }
      var vz = m[7].charAt(0) === '-' ? -1 : 1;
      var zahl = m[7].replace(/[+:\-]/g, '');
      return wand - vz * ((+zahl.slice(0, 2)) * 60 + (+zahl.slice(2, 4))) * 60000;
    }
    var grob = wand - berlinVersatzMin(wand - 3600000) * 60000;
    return wand - berlinVersatzMin(grob) * 60000;
  }

  /* Liegt t im Fenster? Leerer Start = von jeher, leeres Ende = ohne Ende. Ungueltige Angabe = nie. */
  function imFenster(start, ende, t) {
    var a = (start === '' || start == null) ? -Infinity : zeit(start);
    var e = (ende === '' || ende == null) ? Infinity : zeit(ende);
    if (isNaN(a) || isNaN(e)) { return false; }
    return t >= a && t <= e + 999;   /* Ende 23:59:59 gilt bis zur vollen Sekunde, damit zum naechsten Block keine Luecke entsteht */
  }

  /* Restzeit in Teile zerlegen (abgerundet auf ganze Sekunden, nie negativ). */
  function restTeile(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { t: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60, gesamt: s };
  }

  function zwei(n) { return n < 10 ? '0' + n : '' + n; }

  /* ================================================================
     2 · Geld, Warenwert, Stand
     ================================================================ */

  /* 2310 -> "23,10 €" · glatt: 9900 -> "99 €" · CHF -> "23,10 CHF" (wie snippets/mh-mw-geld). */
  function geld(cent, waehrung, glatt) {
    cent = Math.max(0, Math.round(+cent || 0));
    var ganz = Math.floor(cent / 100), rest = cent % 100;
    var z = String(ganz).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (!(glatt && rest === 0)) { z += ',' + zwei(rest); }
    var sym = waehrung === 'EUR' ? '€' : (waehrung === 'GBP' ? '£' : (waehrung || ''));
    /* geschuetztes Leerzeichen (U+00A0) als Zeichencode, nicht als Zeichen: ueberlebt Kopieren durch Editoren, die es in ein normales Leerzeichen wandeln */
    return sym ? z + String.fromCharCode(160) + sym : z;
  }

  /* 2026.6 (14.10.2026): Geschenk-Karte (snippets/mh-mw-fortschritt, vierte Fassung): "liegt im Warenkorb" in allen
     Kontexten, Knopf "Gratis dazulegen" unter der Schwelle grau, Versand-Station, Produktseite unter der Schwelle per Einstellung aus. */

  /* Geschenk-Platzhalter: Zeile ohne Preis (0 € oder 100 % rabattiert) oder mit Property _Gifted o. ae. */
  function istGeschenk(zeile) {
    if (!zeile) { return false; }
    if ((+zeile.final_line_price || 0) <= 0) { return true; }
    var p = zeile.properties;
    if (p && typeof p === 'object') {
      for (var k in p) {
        if (Object.prototype.hasOwnProperty.call(p, k) && /^_gift/i.test(k)) { return true; }
      }
    }
    return false;
  }

  /* 2026.8: Gehoert die Zeile zur Weltkarten-Familie der Stufe 2 (Variante s2v oder Produkt aus s2k bzw. k.s2fam)? */
  function istS2Familie(zeile, k) {
    if (!zeile || !k) { return false; }
    if (k.s2v > 0 && +zeile.variant_id === k.s2v) { return true; }
    return !!(zeile.product_id != null && k.s2fam && k.s2fam[String(zeile.product_id)]);
  }

  /* 2026.8: Produkte, die nicht zur Schwelle zaehlen (wie die Basis-Kollektionen der Shopify-Rabatte).
     s1: Produkte der Geschenk-Plaetze ab Beginn ihres Zeitfensters. s2: dazu die Weltkarten-Familie (k.s2fam).
     Achtung: k.s2a/k.s2e sind Anfang und Ende des Zeitfensters der Stufe 2 (aelter), nicht die Familie. */
  function ausnahmen(k, t) {
    var aus = { s1: {}, s2: {} };
    if (!k) { return aus; }
    for (var i = 0; i < (k.g || []).length; i++) {
      var pid = k.gp ? +k.gp[i] || 0 : 0;
      if (pid > 0 && k.g[i].ok && t >= k.g[i].a) { aus.s1[String(pid)] = true; aus.s2[String(pid)] = true; }
    }
    if (k.s2fam) {
      for (var key in k.s2fam) { if (Object.prototype.hasOwnProperty.call(k.s2fam, key)) { aus.s2[key] = true; } }
    }
    return aus;
  }

  /* Warenwert, den die Schwelle meint: bezahlte Zeilen nach Rabatt, ohne Versand, ohne Geschenk-Platzhalter.
     2026.8: opt.aus1/opt.aus2 = Produkt-IDs ohne Wirkung auf die Schwelle (Stufe 1 / Stufe 2, siehe ausnahmen),
     opt.k = Konfiguration fuer die Zuordnung der Geschenk-Zeilen (Weltkarte = Stufe 2). wert = Stufe 1, wert2 = Stufe 2. */
  function warenwert(cart, opt) {
    var aus = { wert: 0, wert2: 0, artikel: 0, geschenke: 0, geschenke1: 0, geschenke2: 0, produkte: {} };
    if (!cart || !cart.items) { return aus; }
    var mitGutscheinen = !opt || opt.gutscheine !== false;
    var a1 = (opt && opt.aus1) || {}, a2 = (opt && opt.aus2) || {}, k = opt && opt.k;
    var summe = 0, summe2 = 0, i, z, n, pid;
    for (i = 0; i < cart.items.length; i++) {
      z = cart.items[i];
      n = +z.quantity || 0;
      if (istGeschenk(z)) {
        aus.geschenke += n;
        if (k && istS2Familie(z, k)) { aus.geschenke2 += n; } else { aus.geschenke1 += n; }
        continue;
      }
      aus.artikel += n;
      pid = z.product_id != null ? String(z.product_id) : '';
      if (pid) { aus.produkte[pid] = true; }
      if (!mitGutscheinen && z.gift_card) { continue; }
      if (!a1[pid]) { summe += (+z.final_line_price || 0); }
      if (!a1[pid] && !a2[pid]) { summe2 += (+z.final_line_price || 0); }
    }
    var rabatte = cart.cart_level_discount_applications || [];
    for (i = 0; i < rabatte.length; i++) { var r = +rabatte[i].total_allocated_amount || 0; summe -= r; summe2 -= r; }
    aus.wert = Math.max(0, Math.round(summe));
    aus.wert2 = Math.max(0, Math.round(summe2));
    return aus;
  }

  /* Konfiguration aus dem JSON von snippets/mh-mw-konfig in Rechenwerte umsetzen. */
  function leseKonfig(roh) {
    roh = roh || {};
    var k = {
      an: !!roh.an,
      w: roh.w || 'EUR',
      land: roh.land || '',
      s1: Math.max(0, +roh.s1 || 0),
      s2: Math.max(0, +roh.s2 || 0),
      s2a: NaN, s2e: NaN,
      g: [],
      frist: roh.frist ? zeit(roh.frist) : NaN,
      gutscheine: roh.gs !== false,
      vorschlagBis: Math.max(0, +roh.vb || 0),
      zeige: roh.zeige || {},
      vorschau: roh.vorschau === true,
      sz: Math.max(0, +roh.sz || 0) * 1000,
      wurzel: roh.wurzel || '/',
      /* 2026.8: Weltkarte der Stufe 2 (Variante, Regel), ihre Produkt-Familie und die Produkte der Geschenk-Plaetze */
      s2v: Math.max(0, +roh.s2v || 0),
      s2r: String(roh.s2r || ''),
      s2fam: {},
      gp: []
    };
    if (roh.s2f && roh.s2f.length === 2) { k.s2a = zeit(roh.s2f[0]); k.s2e = zeit(roh.s2f[1]) + 999; }
    (roh.s2k || []).forEach(function (id) { if (+id > 0) { k.s2fam[String(+id)] = true; } });
    (roh.gp || []).forEach(function (id, i) { k.gp[i] = Math.max(0, +id || 0); });
    var liste = roh.g || [];
    for (var i = 0; i < liste.length; i++) {
      var a = zeit(liste[i] && liste[i][0]), e = zeit(liste[i] && liste[i][1]) + 999;
      k.g.push({ nr: i + 1, a: a, e: e, ok: !isNaN(a) && !isNaN(e) && e >= a,
        v: Math.max(0, +(roh.gv && roh.gv[i]) || 0), r: String((roh.gr && roh.gr[i]) || '') });
    }
    return k;
  }

  /* Nummer (1..n) des Geschenks, das zum Zeitpunkt t laeuft; 0 = keins. */
  function geschenkNr(k, t) {
    if (!k || !k.g) { return 0; }
    for (var i = 0; i < k.g.length; i++) {
      if (k.g[i].ok && t >= k.g[i].a && t <= k.g[i].e) { return k.g[i].nr; }
    }
    return 0;
  }

  /* Laeuft die Aktion (Hauptschalter an, Schwelle fuer die Waehrung, ein Geschenk im Zeitfenster)? */
  function aktionLaeuft(k, t) { return !!(k && k.an && k.s1 > 0 && geschenkNr(k, t) > 0); }

  /* Laeuft Stufe 2 (eigene Schwelle ueber Stufe 1 und eigenes Zeitfenster)? */
  function stufe2Laeuft(k, t) {
    return !!(aktionLaeuft(k, t) && k.s2 > k.s1 && !isNaN(k.s2a) && !isNaN(k.s2e) && t >= k.s2a && t <= k.s2e);
  }

  /* Stand zum Warenwert: Stufe 0/1/2, Restbetraege, Balkenanteil ueber die ganze Strecke.
     2026.8: wert2 = Warenwert der Stufe 2 (ohne Weltkarten); fehlt er, gilt wert. */
  function stand(wert, k, t, wert2) {
    wert = Math.max(0, Math.round(+wert || 0));
    wert2 = wert2 == null ? wert : Math.max(0, Math.round(+wert2 || 0));
    var aktiv = aktionLaeuft(k, t);
    var s1 = aktiv ? k.s1 : 0;
    var s2 = stufe2Laeuft(k, t) ? k.s2 : 0;
    var r = { aktiv: aktiv, g: aktiv ? geschenkNr(k, t) : 0, s1: s1, s2: s2, wert: wert, wert2: wert2, stufe: 0, rest1: 0, rest2: 0, gesamt: 0, marke1: 100 };
    if (!aktiv) { return r; }
    r.rest1 = Math.max(0, s1 - wert);
    r.rest2 = s2 ? Math.max(0, s2 - wert2) : 0;
    if (wert >= s1) { r.stufe = 1; }
    if (s2 && wert >= s1 && wert2 >= s2) { r.stufe = 2; }
    r.gesamt = Math.min(1, s2 ? (r.stufe >= 1 ? Math.max(s1 / s2, wert2 / s2) : wert / s2) : wert / s1);
    r.marke1 = s2 ? Math.round(s1 / s2 * 1000) / 10 : 100;
    return r;
  }

  /* Welcher Text-Zustand gehoert zum Stand? "0" unter Stufe 1, "1" Stufe 1 erreicht und Stufe 2 offen,
     "1e" Stufe 1 erreicht ohne Stufe 2, "2" beide erreicht. */
  function zustand(st) {
    if (!st.aktiv) { return ''; }
    if (st.stufe === 0) { return '0'; }
    if (st.stufe === 1) { return st.s2 ? '1' : '1e'; }
    return '2';
  }

  /* Liegt das Geschenk der Stufe 1 wirklich im Warenkorb? 2026.8: geschenkZeilen = Geschenk-Zeilen der Stufe 1 (ohne
     Weltkarte), deshalb reicht in jeder Stufe eine. Die Weltkarte hat ihren eigenen Zustand (zustand2). */
  function geschenkDabei(st, geschenkZeilen) {
    var n = +geschenkZeilen || 0;
    if (!st || !st.aktiv || st.stufe === 0) { return false; }
    return n >= 1;
  }

  /* 2026.8: Zustand der Weltkarte (Stufe 2): '' ohne Stufe 2, 'o' Stufe 1 erreicht und Stufe 2 offen,
     'b' Stufe 2 erreicht und Karte noch nicht im Warenkorb, 'd' Karte liegt im Warenkorb. g2 = Geschenk-Zeilen der Stufe 2. */
  function zustand2(st, g2) {
    if (!st || !st.aktiv || !st.s2) { return ''; }
    if (st.stufe === 2) { return (+g2 || 0) >= 1 ? 'd' : 'b'; }
    return st.stufe === 1 ? 'o' : '';
  }

  /* Text-Zustand im Warenkorb: wie zustand(), mit angehaengtem "d", wenn das Geschenk wirklich im Warenkorb liegt
     ("ist dabei"). Ohne Geschenk-Zeile bleibt es beim neutralen "Warenwert erreicht". */
  function textZustand(st, geschenkZeilen) {
    var z = zustand(st);
    return z && geschenkDabei(st, geschenkZeilen) ? z + 'd' : z;
  }

  /* Soll ein Zubehoer-Vorschlag gezeigt werden? fuer: 1 oder 2 (Stufe), preis in Cent. */
  function vorschlagPasst(st, k, fuer, preis) {
    if (!st.aktiv || !k.vorschlagBis || !(preis > 0)) { return false; }
    if (+fuer === 1) { return st.stufe === 0 && st.rest1 > 0 && st.rest1 <= k.vorschlagBis && preis >= st.rest1; }
    if (+fuer === 2) { return st.stufe === 1 && st.s2 > 0 && st.rest2 > 0 && st.rest2 <= k.vorschlagBis && preis >= st.rest2; }
    return false;
  }

  /* ================================================================
     3 · Testzeit (nur Theme-Editor und Vorschau eines unveroeffentlichten Themes)
     ================================================================ */

  var test = { delta: 0, korb: null, geschenke: 0, aktiv: false };
  var uhrVersatz = 0;        /* Korrektur, wenn die Uhr des Besuchers vor der Serverzeit der Seite steht */
  var SPEICHER = 'mhmw_test';
  var VORSCHAU_ROLLEN = { unpublished: true, development: true, demo: true };

  function parameter(suche) {
    var aus = {};
    String(suche || '').replace(/^\?/, '').split('&').forEach(function (teil) {
      if (!teil) { return; }
      var p = teil.split('=');
      try { aus[decodeURIComponent(p[0])] = decodeURIComponent((p[1] || '').replace(/\+/g, ' ')); } catch (e) { /* kaputte Kodierung ignorieren */ }
    });
    return aus;
  }

  /* Darf hier getestet werden? Ja im Theme-Editor (Shopify.designMode, dokumentiert). In der Vorschau nur, wenn
     BEIDE Seiten "nicht veroeffentlicht" melden: das servergerenderte JSON (Liquid theme.role) und Shopify.theme.role
     im Browser. Fehlt eine der Angaben oder steht sie auf "main", gibt es keinen Testmodus. Ein Parameter in der
     Adresse kann das nicht aendern. */
  function testErlaubt(shopify, k) {
    shopify = shopify || {};
    if (shopify.designMode === true) { return true; }
    var rolle = shopify.theme && shopify.theme.role;
    return !!(k && k.vorschau === true && typeof rolle === 'string' && VORSCHAU_ROLLEN[rolle] === true);
  }

  /* Reine Entscheidung (testbar): Was gilt bei diesen Parametern? Ohne Erlaubnis gilt nichts, und ein
     gespeicherter Stand wird geloescht. */
  function testAusParametern(p, erlaubt, echtJetzt, gespeichert) {
    var aus = { delta: 0, korb: null, geschenke: 0, aktiv: false, loeschen: false, speichern: false };
    if (!erlaubt) { aus.loeschen = true; return aus; }
    if (p.mw_now === 'off') { aus.loeschen = true; return aus; }
    if (gespeichert && typeof gespeichert.delta === 'number') {
      aus.delta = gespeichert.delta; aus.korb = gespeichert.korb == null ? null : gespeichert.korb;
      aus.geschenke = +gespeichert.geschenke || 0; aus.aktiv = true;
    }
    if (p.mw_now) {
      var t = zeit(p.mw_now);
      if (!isNaN(t)) { aus.delta = t - echtJetzt; aus.aktiv = true; aus.speichern = true; }
    }
    if (p.mw_cart != null && p.mw_cart !== '') {
      if (p.mw_cart === 'off') { aus.korb = null; aus.geschenke = 0; aus.speichern = aus.aktiv; }
      else if (/^\d+$/.test(p.mw_cart)) { aus.korb = parseInt(p.mw_cart, 10); aus.aktiv = true; aus.speichern = true; }
    }
    if (p.mw_gift != null && /^\d$/.test(p.mw_gift)) { aus.geschenke = parseInt(p.mw_gift, 10); aus.speichern = aus.aktiv; }
    return aus;
  }

  function ladeTest() {
    if (!win || !win.location) { return; }
    var gespeichert = null;
    try { gespeichert = JSON.parse(win.sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) { gespeichert = null; }
    var r = testAusParametern(parameter(win.location.search), testErlaubt(win.Shopify, konfig), Date.now(), gespeichert);
    try {
      if (r.loeschen) { win.sessionStorage.removeItem(SPEICHER); }
      else if (r.speichern) { win.sessionStorage.setItem(SPEICHER, JSON.stringify({ delta: r.delta, korb: r.korb, geschenke: r.geschenke })); }
    } catch (e2) { /* privater Modus: Test gilt dann nur fuer diese Seite */ }
    test.delta = r.delta; test.korb = r.korb; test.geschenke = r.geschenke; test.aktiv = r.aktiv;
  }

  /* Uhr des Besuchers gegen die Serverzeit der Seite: nur nach vorn korrigieren (eine Seite ist nie juenger als jetzt). */
  function versatzAus(serverMs, geraetMs) {
    return (serverMs > 0 && geraetMs < serverMs) ? serverMs - geraetMs : 0;
  }

  function jetzt() { return Date.now() + (test.aktiv && test.delta !== 0 ? test.delta : uhrVersatz); }

  /* ================================================================
     4 · DOM-Teil (laeuft nur im Browser)
     ================================================================ */

  var konfig = leseKonfig(null);
  var korb = { bekannt: false, wert: 0, wert2: 0, artikel: 0, geschenke: 0, geschenke1: 0, geschenke2: 0, produkte: {} };
  var wartend = 0;           /* Zeitpunkt des letzten Klicks auf "In den Warenkorb" (Modal rechnet das Produkt dann schon mit) */
  var erzwungen = null;      /* im Theme-Editor angeklickter Phasen-Block */
  var uhr = null;
  var weiterGeplant = false;
  var weiterUhr = null;

  function alle(sel, wurzel) { return Array.prototype.slice.call((wurzel || doc).querySelectorAll(sel)); }
  function setzeHidden(el, aus) { if (el && el.hidden !== aus) { el.hidden = aus; } }
  function setzeText(el, text) { if (el && el.textContent !== text) { el.textContent = text; } }
  function setzeStil(el, name, wert) { if (el && el.style.getPropertyValue(name).replace(/^\s+|\s+$/g, '') !== wert) { el.style.setProperty(name, wert); } }

  function ladeKonfig() {
    var el = doc.querySelector('script[data-mhmw-konfig]');
    if (!el) { return; }
    try { konfig = leseKonfig(JSON.parse(el.textContent || '{}')); } catch (e) { konfig = leseKonfig(null); }
    uhrVersatz = versatzAus(konfig.sz, Date.now());
  }

  /* ---- Warenkorb ---- */

  function nimmKorb(cart) {
    if (!cart || !cart.items) { return; }
    var aus = ausnahmen(konfig, jetzt());
    var w = warenwert(cart, { gutscheine: konfig.gutscheine, aus1: aus.s1, aus2: aus.s2, k: konfig });
    korb.bekannt = true; korb.wert = w.wert; korb.wert2 = w.wert2; korb.artikel = w.artikel; korb.geschenke = w.geschenke;
    korb.geschenke1 = w.geschenke1; korb.geschenke2 = w.geschenke2; korb.produkte = w.produkte;
    wartend = 0;
    zeigeStaende();
    raeumeAuf(cart);
  }

  function holeKorb(immer) {
    if ((korb.bekannt && !immer) || !win.fetch) { return; }
    win.fetch(konfig.wurzel.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && (immer || !korb.bekannt)) { nimmKorb(c); } })
      .catch(function () { /* Anzeige bleibt beim servergerenderten Stand */ });
  }

  /* Manche Bausteine des Themes melden nur "Warenkorb hat sich geaendert", ohne den Warenkorb mitzuschicken.
     Dann einmal nachladen (gebuendelt), aber nur wenn auf der Seite ein Fortschritt steht und die Aktion laeuft. */
  var abrufUhr = null;
  function planeAbruf() {
    if (abrufUhr || !doc.querySelector('[data-mhmw="stand"]') || !aktionLaeuft(konfig, jetzt())) { return; }
    abrufUhr = win.setTimeout(function () { abrufUhr = null; holeKorb(true); }, 350);
  }

  function menge() {
    var feld = doc.querySelector('.product-form [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    var n = feld ? parseInt(feld.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* ---- Geschenk-Fortschritt (Warenkorb, Modal, Produktseite) ---- */

  function zeigeStand(el) {
    var kontext = el.getAttribute('data-kontext') || 'warenkorb';
    var schalter = kontext === 'warenkorb' ? konfig.zeige.wk : (kontext === 'modal' ? konfig.zeige.modal : konfig.zeige.pdp);
    var basis = test.korb != null ? test.korb : korb.wert;
    var basis2 = test.korb != null ? test.korb : korb.wert2;
    var preis = parseInt(el.getAttribute('data-preis'), 10) || 0;
    if (kontext === 'pdp') {
      /* Liegt das Produkt schon im Warenkorb, steckt sein Preis bereits im Warenwert: nicht doppelt zaehlen.
         2026.8: Geschenk-Produkte zaehlen nicht (Stufe 1: laufende/vergangene Geschenke, Stufe 2: zusaetzlich Weltkarten). */
      var pid = el.getAttribute('data-produkt');
      var imKorb = test.korb != null ? false : (korb.bekannt ? !!(pid && korb.produkte[pid]) : el.getAttribute('data-im-korb') === '1');
      if (!imKorb) {
        var ohne = ausnahmen(konfig, jetzt());
        if (!ohne.s1[pid]) { basis += preis; }
        if (!ohne.s2[pid]) { basis2 += preis; }
      }
    }
    else if (kontext === 'modal' && wartend && test.korb == null) { basis += preis * menge(); basis2 += preis * menge(); }
    var st = stand(basis, konfig, jetzt(), basis2);
    var sichtbar = st.aktiv && schalter !== false;
    /* Warenkorb ohne bezahlten Artikel (leer oder nur Geschenk-Zeilen): keine Karte, wie im Snippet */
    if (kontext === 'warenkorb' && korb.artikel <= 0 && test.korb == null) { sichtbar = false; }
    var z = zustand(st);
    /* Produktseite unter der Schwelle: per Einstellung ganz aus (Vierte Fassung 14.10.2026) */
    if (kontext === 'pdp' && z === '0' && el.getAttribute('data-pdp-unter') === 'aus') { sichtbar = false; }
    setzeHidden(el, !sichtbar);
    if (!sichtbar) { return; }
    if (el.getAttribute('data-zustand') !== z) { el.setAttribute('data-zustand', z); }
    /* "liegt im Warenkorb" in allen Kontexten, sobald die Geschenk-Zeile wirklich im Warenkorb liegt.
       2026.8: getrennt je Stufe. Test ?mw_gift=1: Geschenk der Stufe 1 drin, ?mw_gift=2: dazu die Weltkarte. */
    var serverG1 = el.hasAttribute('data-geschenke1') ? el.getAttribute('data-geschenke1') : el.getAttribute('data-geschenke');
    var gz = test.korb != null ? Math.min(1, test.geschenke) : (korb.bekannt ? korb.geschenke1 : (parseInt(serverG1, 10) || 0));
    var gz2 = test.korb != null ? (test.geschenke >= 2 ? 1 : 0) : (korb.bekannt ? korb.geschenke2 : (parseInt(el.getAttribute('data-geschenke2'), 10) || 0));
    var zt = textZustand(st, gz);
    var dabei = zt !== z ? '1' : '0';
    if (el.getAttribute('data-dabei') !== dabei) { el.setAttribute('data-dabei', dabei); }
    alle('[data-z]', el).forEach(function (teil) { setzeHidden(teil, teil.getAttribute('data-z').split(' ').indexOf(zt) === -1); });
    /* Stufe 2 (Weltkarte): eigener Zustand o/b/d und eigener Knopf */
    var z2 = zustand2(st, gz2);
    if ((el.getAttribute('data-zustand2') || '') !== z2) { el.setAttribute('data-zustand2', z2); }
    alle('[data-z2]', el).forEach(function (teil) { setzeHidden(teil, teil.getAttribute('data-z2').split(' ').indexOf(z2) === -1); });
    alle('[data-mhmw-wahl2]', el).forEach(function (btn) {
      if (btn.hasAttribute('data-mhmw-gesperrt')) { return; }
      var aus2 = z2 !== 'b';
      if (btn.disabled !== aus2 && btn.getAttribute('aria-busy') !== 'true') { btn.disabled = aus2; }
    });
    alle('[data-mhmw-rest]', el).forEach(function (b) {
      setzeText(b, geld(b.getAttribute('data-mhmw-rest') === '2' ? st.rest2 : st.rest1, konfig.w));
    });
    alle('[data-mhmw-nur-s2]', el).forEach(function (teil) { setzeHidden(teil, !st.s2); });
    /* Knopf "Gratis dazulegen": unter der Schwelle grau (zeigt, was gleich passiert), erreicht aktiv, im Warenkorb weg (data-z) */
    alle('[data-mhmw-wahl]', el).forEach(function (btn) {
      var aus = z === '0';
      if (btn.hasAttribute('data-mhmw-gesperrt')) { return; }
      if (btn.disabled !== aus && btn.getAttribute('aria-busy') !== 'true') { btn.disabled = aus; }
    });
    /* Versand-Station: erreicht ab dem Freibetrag (Focal-Einstellung), ohne Geschenk-Zeilen gerechnet wie die Schwelle */
    var versand = parseInt(el.getAttribute('data-versand'), 10) || 0;
    var versandDa = versand > 0 && basis >= versand ? '1' : '0';
    if (el.getAttribute('data-versand-da') !== versandDa) { el.setAttribute('data-versand-da', versandDa); }
    alle('[data-mhmw-versand-text]', el).forEach(function (t) { setzeHidden(t, t.getAttribute('data-mhmw-versand-text') !== versandDa); });
    if (el.classList.contains('mhmw-gk--zwei') !== !!st.s2) { el.classList.toggle('mhmw-gk--zwei', !!st.s2); }
    if (el.classList.contains('mhmw-fs--zwei') !== !!st.s2 && el.classList.contains('mhmw-fs')) { el.classList.toggle('mhmw-fs--zwei', !!st.s2); }
    setzeStil(el, '--mhmw-p', (Math.round(st.gesamt * 1000) / 10) + '%');
    setzeStil(el, '--mhmw-m1', st.marke1 + '%');
    var balken = el.querySelector('[role="progressbar"]');
    var prozent = String(Math.round(st.gesamt * 100));
    if (balken && balken.getAttribute('aria-valuenow') !== prozent) { balken.setAttribute('aria-valuenow', prozent); }
    alle('[data-mhmw-vorschlag]', el).forEach(function (v) {
      setzeHidden(v, !vorschlagPasst(st, konfig, v.getAttribute('data-mhmw-vorschlag'), parseInt(v.getAttribute('data-preis'), 10) || 0));
    });
  }

  function zeigeStaende() { alle('[data-mhmw="stand"]').forEach(zeigeStand); }

  /* ---- "Geschenk auswaehlen": Pop-up der App oeffnen ---- */

  var WAHL_MODAL = '#aca-modal, #aca-modal-wrapper';
  /* Erinnerungs-Banner der App (Design > Reminder Banners, je Regel aktivierbar). Ein Klick darauf oeffnet das
     Pop-up der App erneut (aus dem App-Skript gelesen 13.10.2026: Klasse aca-reminder-banner-container,
     Attribut easygift-reminder-banner-rule). Die Regel-Banner (.aca-banner-container) koennen auf eine
     andere Seite fuehren und sind deshalb bewusst NICHT dabei. */
  var WAHL_BANNER = '.aca-reminder-banner-container[easygift-reminder-banner-rule], .aca-reminder-banner-container';

  /* Reine Entscheidung (testbar): "modal" wenn das Pop-up im Markup steht, "banner" wenn das Erinnerungs-Banner da ist, sonst "neu". */
  function wahlWeg(hatModal, hatBanner) {
    if (hatModal) { return 'modal'; }
    if (hatBanner) { return 'banner'; }
    return 'neu';
  }

  function waehleGeschenk(btn) {
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') { return 'laeuft'; }
      btn.setAttribute('aria-busy', 'true');
    }
    var modal = doc.querySelector(WAHL_MODAL);
    var banner = doc.querySelector(WAHL_BANNER);
    var g = geschenkJetzt();
    /* Reihenfolge (Lars 13.10.: das Pop-up der App soll wiederkommen): 1. offenes Pop-up zeigen, 2. Erinnerungs-Banner
       anklicken, die App oeffnet ihr Pop-up erneut, 3. nur wenn beides fehlt, selbst einlegen (gleicher App-Rabatt). */
    if (!modal && !banner && g && g.v > 0 && g.r && win.fetch) {
      legeEin(g).then(function (ergebnis) {
        if (ergebnis === 'ok') { if (btn) { btn.removeAttribute('aria-busy'); } return; }
        if (ergebnis === 'fehler') { win.location.reload(); return; }
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = true; }
        /* 2026.8: ausverkauft (422): kein Neuladen in Schleife, sondern die Meldung unter dem Knopf */
        if (ergebnis === 'leer') { zeigeAblehnung(btn, ''); return; }
        if (ergebnis === 'abgelehnt') {
          /* 2026.7: verstaendliche Meldung statt "Gerade nicht moeglich"; Knopftext bleibt ("Gratis dazulegen").
             Auf der Warenkorbseite nicht fuer das Aufraeumen neu laden (raeumeAuf -> neuZeichnen), sonst ist die Zeile weg;
             die abgelehnte Geschenkzeile war dort ohnehin nie zu sehen. */
          try { win.sessionStorage.setItem('mhmw_neu', String(Date.now())); } catch (e) { /* dann eben neu laden */ }
          zeigeAblehnung(btn, andererRabatt(abgelehntKorb, g.r));
        }
      });
      return 'selbst';
    }
    var weg = wahlWeg(!!modal, !!banner);
    if (weg === 'modal') {
      modal = modal.closest('#aca-modal') || modal;
      modal.removeAttribute('hidden');
      modal.style.display = 'block';
      if (btn) { btn.removeAttribute('aria-busy'); }
      return weg;
    }
    if (weg === 'banner') {
      try { banner.click(); } catch (e) { /* dann neu laden */ }
      win.setTimeout(function () { if (btn) { btn.removeAttribute('aria-busy'); } }, 1500);
      wartAufAppGeschenk();
      return weg;
    }
    /* Die App prueft ihre Regeln beim Laden der Seite und zeigt das Pop-up erneut (Regel ohne "einmal je Sitzung") */
    win.setTimeout(function () { win.location.reload(); }, 50);
    return weg;
  }

  /* ---- Stufe 2: Weltkarte mit eigenem Knopf (2026.8, 20.10.2026) ----
     Legt genau die eine Karte aus dem Theme-Editor ein (Varianten-ID s2v, Regel s2r = custom.eg_regel der Karte,
     Property _q = geschenk-button-s2). Den Preis 0 € setzt der Shopify-Rabatt "MagicWeeks: Gratis-Weltkarte ab 199 €".
     Kostet die Zeile danach etwas, nimmt raeumeAuf sie wieder heraus, und unter dem Knopf steht die Meldung. Kein Neuladen. */
  function waehleGeschenk2(btn) {
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') { return 'laeuft'; }
      btn.setAttribute('aria-busy', 'true');
    }
    var g = (stufe2Laeuft(konfig, jetzt()) && konfig.s2v > 0 && konfig.s2r && win.fetch) ? { v: konfig.s2v, r: konfig.s2r } : null;
    if (!g) {
      if (btn) { btn.removeAttribute('aria-busy'); }
      zeigeAblehnung(btn, '');
      return 'aus';
    }
    legeEin(g, 'geschenk-button-s2').then(function (ergebnis) {
      if (btn) { btn.removeAttribute('aria-busy'); }
      if (ergebnis === 'ok') { return; }
      if (btn) { btn.disabled = true; }
      try { win.sessionStorage.setItem('mhmw_neu', String(Date.now())); } catch (e) { /* dann eben ohne */ }
      zeigeAblehnung(btn, ergebnis === 'abgelehnt' ? andererRabatt(abgelehntKorb, g.r) : '');
    });
    return 'selbst';
  }

  /* ---- Geschenk selbst einlegen und teure Geschenkzeilen aufraeumen (13.10.2026) ---- */

  function basis() { return String(konfig.wurzel || '/').replace(/\/$/, ''); }
  function aufKorbseite() { return /\/cart\/?$/.test((win.location && win.location.pathname) || ''); }

  /* Wert der App-Property (_Gifted o. ae.) einer Zeile, sonst '' */
  function geschenkRegel(zeile) {
    var p = zeile && zeile.properties;
    if (!p || typeof p !== 'object') { return ''; }
    for (var k in p) {
      if (Object.prototype.hasOwnProperty.call(p, k) && /^_gift/i.test(k) && p[k] != null && String(p[k]) !== '') { return String(p[k]); }
    }
    return '';
  }

  /* Reine Entscheidung (testbar): Schluessel der App-Geschenkzeilen, die etwas kosten. */
  function teureGeschenke(cart) {
    var aus = [];
    if (!cart || !cart.items) { return aus; }
    for (var i = 0; i < cart.items.length; i++) {
      var z = cart.items[i];
      if (z && z.key && geschenkRegel(z) && (+z.final_line_price || 0) > 0) { aus.push(z.key); }
    }
    return aus;
  }

  /* Geschenk, das gerade laeuft (Eintrag aus konfig.g), sonst null */
  function geschenkJetzt() {
    var t = jetzt();
    var nr = aktionLaeuft(konfig, t) ? geschenkNr(konfig, t) : 0;
    return nr && konfig.g[nr - 1] ? konfig.g[nr - 1] : null;
  }

  function postJson(pfad, daten) {
    return win.fetch(basis() + pfad, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function holeKorbJson() {
    return win.fetch(basis() + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Warenkorb neu anzeigen: auf der Warenkorbseite neu laden (Focal rendert die Seite serverseitig), sonst Theme-Event.
     Ohne "erzwingen" hoechstens einmal je 15 Sekunden neu laden (keine Schleife, falls das Entfernen nicht greift). */
  function neuZeichnen(c, erzwingen) {
    if (aufKorbseite()) {
      var darf = true;
      if (!erzwingen) {
        try {
          var zuletzt = +win.sessionStorage.getItem('mhmw_neu') || 0;
          if (Date.now() - zuletzt < 15000) { darf = false; } else { win.sessionStorage.setItem('mhmw_neu', String(Date.now())); }
        } catch (e) { /* ohne sessionStorage einfach neu laden */ }
      }
      if (darf) { win.location.reload(); return; }
    }
    if (c && c.items) { nimmKorb(c); }
    try { doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } })); } catch (e) { /* alte Browser */ }
  }

  var aufgeraeumt = {};
  function raeumeAuf(cart) {
    if (!win.fetch) { return; }
    var weg = teureGeschenke(cart).filter(function (k) { return !aufgeraeumt[k]; });
    if (!weg.length) { return; }
    var updates = {};
    weg.forEach(function (k) { aufgeraeumt[k] = true; updates[k] = 0; });
    postJson('/cart/update.js', { updates: updates })
      .then(function (c) { if (c && c.items) { neuZeichnen(c, false); } })
      .catch(function () { /* bleibt stehen, naechster Warenkorb-Stand versucht es nicht erneut */ });
  }

  /* Nach dem Banner-Klick legt die App das Geschenk selbst ein, die Warenkorbseite weiss davon nichts
     (App-Einstellung autoReloadCartPage aus). Darum bis zu 40 Sekunden alle 2 Sekunden nachsehen und
     neu zeichnen, sobald eine Geschenk-Zeile zu 0 EUR da ist. */
  var wartUhr = null;
  function wartAufAppGeschenk() {
    if (!win.fetch || wartUhr) { return; }
    var bis = Date.now() + 40000;
    wartUhr = win.setInterval(function () {
      if (Date.now() > bis) { win.clearInterval(wartUhr); wartUhr = null; return; }
      holeKorbJson().then(function (c) {
        if (!c || !c.items || !wartUhr) { return; }
        for (var i = 0; i < c.items.length; i++) {
          if (geschenkRegel(c.items[i]) && (+c.items[i].final_line_price || 0) === 0) {
            win.clearInterval(wartUhr); wartUhr = null;
            neuZeichnen(c, true);
            return;
          }
        }
      }).catch(function () { /* naechster Versuch */ });
    }, 2000);
  }

  /* 2026.7: Warenkorb im Moment der Ablehnung (Geschenkzeile noch drin), fuer die Meldung unter dem Knopf */
  var abgelehntKorb = null;

  /* Reine Entscheidung (testbar): Titel des ersten anderen Rabatts im Warenkorb, der nicht zur Geschenk-Regel gehoert, sonst ''.
     Geschenkzeilen (_Gifted o. ae.) und Titel gleich dem Regelnamen zaehlen nicht. */
  function andererRabatt(cart, regel) {
    if (!cart || !cart.items) { return ''; }
    var r = String(regel || '').toLowerCase();
    /* 2026.8: Titel mit "Gratis" sind die Geschenk-Rabatte selbst (VIP Day / MagicWeeks), die nennen wir nicht als Grund */
    function passt(t) { t = String(t || '').replace(/^\s+|\s+$/g, ''); return t && t.toLowerCase() !== r && !/gratis/i.test(t) ? t : ''; }
    for (var i = 0; i < cart.items.length; i++) {
      var z = cart.items[i];
      /* 2026.8: auch 0-€-Zeilen ueberspringen (deren Rabatt ist ein Geschenk-Rabatt, z. B. ein bezahlter Stern, den der Rabatt gratis macht) */
      if (!z || geschenkRegel(z) || (+z.final_line_price || 0) <= 0) { continue; }
      var ds = z.discounts || [];
      for (var j = 0; j < ds.length; j++) { var t1 = passt(ds[j] && ds[j].title); if (t1) { return t1; } }
      var la = z.line_level_discount_allocations || [];
      for (var k = 0; k < la.length; k++) { var t2 = passt(la[k] && la[k].discount_application && la[k].discount_application.title); if (t2) { return t2; } }
    }
    var ca = cart.cart_level_discount_applications || [];
    for (var m = 0; m < ca.length; m++) { var t3 = passt(ca[m] && ca[m].title); if (t3) { return t3; } }
    return '';
  }

  /* Meldung unter dem Knopf (eine Zeile, role=status), Knopf bleibt gesperrt */
  function zeigeAblehnung(btn, titel) {
    if (!btn || !doc) { return; }
    btn.disabled = true;
    btn.setAttribute('data-mhmw-gesperrt', '1');
    var text = titel ? 'Geht leider nicht zusammen mit „' + titel + '“.' : 'Hat gerade nicht geklappt. Bitte lade die Seite neu.';
    var p = btn.nextElementSibling && btn.nextElementSibling.classList && btn.nextElementSibling.classList.contains('mhmw-gk__hinweis') ? btn.nextElementSibling : null;
    if (!p) {
      p = doc.createElement('p');
      p.className = 'mhmw-gk__hinweis';
      p.setAttribute('role', 'status');
      p.style.flex = '1 1 100%';
      btn.insertAdjacentElement('afterend', p);
    }
    setzeText(p, text);
  }

  /* Geschenk g ({v: Varianten-ID, r: Regelname}) einlegen. Ergebnis: 'ok' | 'abgelehnt' (Server gibt keinen Rabatt) |
     'leer' (2026.8: Shopify nimmt die Variante nicht an, HTTP 422, z. B. ausverkauft) | 'fehler' */
  function legeEin(g, quelle) {
    var props = { _q: quelle || 'geschenk-button' };
    props._Gifted = g.r;
    return win.fetch(basis() + '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: g.v, quantity: 1, properties: props }] })
    })
      .then(function (r) { return r.status === 422 ? 'leer' : (r.ok ? r.json() : null); })
      .then(function (a) {
        if (a === 'leer') { return 'leer'; }
        if (!a) { return 'fehler'; }
        return holeKorbJson().then(function (c) {
          if (!c || !c.items) { return 'fehler'; }
          var gut = false;
          for (var i = 0; i < c.items.length; i++) {
            var z = c.items[i];
            if (+z.variant_id === +g.v && geschenkRegel(z) === g.r && (+z.final_line_price || 0) === 0) { gut = true; }
          }
          if (gut) { neuZeichnen(c, true); return 'ok'; }
          abgelehntKorb = c;
          raeumeAuf(c);
          return 'abgelehnt';
        });
      })
      .catch(function () { return 'fehler'; });
  }

  /* ---- Geschenk-Namen, Bedingungen, Zeitfenster ---- */

  function zeigeGeschenke(t) {
    var nr = aktionLaeuft(konfig, t) ? geschenkNr(konfig, t) : 0;
    var s2 = stufe2Laeuft(konfig, t);
    alle('[data-mhmw-g]').forEach(function (slot) {
      if (slot.hasAttribute('data-fest') || slot.hasAttribute('data-phasen-geschenk')) { return; }
      alle('[data-g]', slot).forEach(function (kind) { setzeHidden(kind, parseInt(kind.getAttribute('data-g'), 10) !== nr); });
    });
    /* data-mhmw-wenn: Bedingungen mit Leerzeichen getrennt, alle muessen gelten.
       g = ein Geschenk laeuft, !g = keins, s2 = Stufe 2 laeuft, !s2 = nicht. */
    alle('[data-mhmw-wenn]').forEach(function (el) {
      if (el.hasAttribute('data-phasen-s2')) { return; }
      var ok = true;
      (el.getAttribute('data-mhmw-wenn') || '').split(' ').forEach(function (w) {
        if (w === 'g') { ok = ok && nr !== 0; }
        else if (w === '!g') { ok = ok && nr === 0; }
        else if (w === 's2') { ok = ok && s2; }
        else if (w === '!s2') { ok = ok && !s2; }
      });
      setzeHidden(el, !ok);
    });
    alle('[data-mhmw-fenster]').forEach(function (el) {
      setzeHidden(el, !imFenster(el.getAttribute('data-start'), el.getAttribute('data-ende'), t));
    });
  }

  /* ---- Countdown ---- */

  function zielVon(cd, block) {
    var z = cd.getAttribute('data-ziel') || 'ende';
    if (z === 'ende') { return block ? zeit(block.getAttribute('data-ende')) : NaN; }
    if (z === 'frist') { return konfig.frist; }
    return zeit(z);
  }

  function zeigeCountdown(cd, t, block) {
    var ziel = zielVon(cd, block);
    var rest = ziel - t;
    var ab = cd.getAttribute('data-ab');
    var zeigen = !isNaN(ziel) && rest > 0;
    if (zeigen && ab !== null && ab !== '') { zeigen = rest <= (parseFloat(ab) || 0) * 3600000; }
    setzeHidden(cd, !zeigen);
    if (!zeigen) { return false; }
    var r = restTeile(rest);
    setzeText(cd.querySelector('[data-t]'), zwei(r.t));
    setzeText(cd.querySelector('[data-h]'), zwei(r.h));
    setzeText(cd.querySelector('[data-m]'), zwei(r.m));
    setzeText(cd.querySelector('[data-s]'), zwei(r.s));
    var mitTagen = r.t > 0;
    alle('[data-nur-tage]', cd).forEach(function (el) { setzeHidden(el, !mitTagen); });
    alle('[data-ein-tag]', cd).forEach(function (el) { setzeHidden(el, r.t !== 1); });
    alle('[data-mehr-tage]', cd).forEach(function (el) { setzeHidden(el, r.t === 1); });
    /* Vorlesetext nur im Minutentakt aendern */
    setzeText(cd.querySelector('[data-vt]'), String(r.t));
    setzeText(cd.querySelector('[data-vh]'), String(r.h));
    setzeText(cd.querySelector('[data-vm]'), String(r.m));
    return true;
  }

  /* ---- Phasen (Landingpage, Leiste, Hub-Hinweis) ---- */

  function eigeneKinder(c, sel) {
    return alle(sel, c).filter(function (el) { return el.closest('[data-mhmw="phasen"]') === c; });
  }

  function zeigePhasen(c, t) {
    var bloecke = eigeneKinder(c, '[data-mhmw-b]');
    var aktiv = null;
    if (erzwungen && bloecke.indexOf(erzwungen) > -1) { aktiv = erzwungen; }
    else {
      for (var i = 0; i < bloecke.length; i++) {
        var b = bloecke[i];
        if (b.hasAttribute('data-braucht-aktion') && !aktionLaeuft(konfig, t)) { continue; }
        if (imFenster(b.getAttribute('data-start'), b.getAttribute('data-ende'), t)) { aktiv = b; break; }
      }
    }
    bloecke.forEach(function (b) { setzeHidden(b, b !== aktiv); });
    var kennung = aktiv ? (aktiv.getAttribute('data-mhmw-b') || 'x') : '';
    if (c.getAttribute('data-phase') !== kennung) { c.setAttribute('data-phase', kennung); }
    if (c.getAttribute('data-leer') === 'weg') { setzeHidden(c, !aktiv); }
    var cdDa = false;
    if (aktiv) {
      if (aktiv.hasAttribute('data-frist')) {
        var vor = isNaN(konfig.frist) ? null : t < konfig.frist;
        alle('[data-fr]', aktiv).forEach(function (el) {
          var f = el.getAttribute('data-fr');
          setzeHidden(el, vor === null ? f !== 'ohne' : (f === 'vor' ? !vor : (f === 'nach' ? vor : true)));
        });
      }
      alle('[data-mhmw-cd]', aktiv).forEach(function (cd) { if (zeigeCountdown(cd, t, aktiv)) { cdDa = true; } });
      /* Button mit Sprungmarke (#magicdeals): ausblenden, wenn es das Ziel auf der Seite gerade nicht gibt
         (Collection leer, nicht gewaehlt oder Bereich ausserhalb seines Zeitfensters). Sonst passiert beim Klick nichts. */
      alle('a[data-mhmw-anker]', aktiv).forEach(function (a) {
        var marke = (a.getAttribute('href') || '').replace(/^#/, '');
        var ziel = marke ? doc.getElementById(marke) : null;
        setzeHidden(a.parentNode, !ziel || !!(ziel.closest && ziel.closest('[hidden]')));
      });
      var weiter = aktiv.getAttribute('data-weiter');
      if (weiter && !weiterGeplant && !test.aktiv && !(win.Shopify && win.Shopify.designMode)) {
        weiterGeplant = true;
        weiterUhr = win.setTimeout(function () { win.location.href = weiter; }, (parseFloat(aktiv.getAttribute('data-weiter-sek')) || 6) * 1000);
      }
    }
    c.classList.toggle('hat-countdown', cdDa);
    /* Geschenk-Karte der Landingpage: laufendes Geschenk, festes Geschenk des Blocks oder keine Karte */
    var huelle = c.querySelector('[data-phasen-geschenk-wrap]');
    if (huelle) {
      var wahl = aktiv ? (aktiv.getAttribute('data-geschenk') || 'auto') : 'keins';
      var nr = 0;
      /* nur "auto" nutzt die gemeinsame Karte; feste und eigene Karten stehen im Phasen-Block selbst */
      if (konfig.an && konfig.s1 > 0 && wahl === 'auto') { nr = geschenkNr(konfig, t); }
      var gefunden = false;
      alle('[data-phasen-geschenk] > [data-g]', huelle).forEach(function (karte) {
        var passt = nr > 0 && parseInt(karte.getAttribute('data-g'), 10) === nr;
        if (passt) { gefunden = true; }
        setzeHidden(karte, !passt);
      });
      setzeHidden(huelle, !gefunden);
      var s2Karte = gefunden && wahl === 'auto' && stufe2Laeuft(konfig, t);
      setzeHidden(huelle.querySelector('[data-phasen-s2]'), !s2Karte);
      /* Stufe 2 als Hauptzeile (Karte zuerst) nur in Phasen mit data-s2-haupt (MagicWeek 4), sonst zweite Zeile (nur Darstellung) */
      var s2Haupt = s2Karte && !!aktiv && aktiv.getAttribute('data-s2-haupt') === '1';
      if (huelle.classList.contains('ist-s2') !== s2Haupt) { huelle.classList.toggle('ist-s2', s2Haupt); }
    }
    var zlOffen = false;
    eigeneKinder(c, '[data-mhmw-zl]').forEach(function (el) {
      var a = zeit(el.getAttribute('data-start')), e = zeit(el.getAttribute('data-ende'));
      var s = (!isNaN(e) && t > e + 999) ? 'vorbei' : ((!isNaN(a) && t < a) ? 'kommt' : 'jetzt');
      if (s !== 'vorbei') { zlOffen = true; }
      if (el.getAttribute('data-stand') !== s) {
        el.setAttribute('data-stand', s);
        if (s === 'jetzt') { el.setAttribute('aria-current', 'step'); } else { el.removeAttribute('aria-current'); }
      }
    });
    /* Zeitleiste ("Der Fahrplan") entfaellt, sobald alles vorbei ist */
    setzeHidden(c.querySelector('[data-mhmw-zl-huelle]'), !zlOffen);
  }

  /* ---- Takt ---- */

  function takt() {
    if (!doc) { return; }
    var t = jetzt();
    /* Alles wird jede Sekunde nachgezogen. Geschrieben wird nur, was sich geaendert hat (setzeHidden, setzeText,
       setzeStil vergleichen vorher). So stimmt auch Markup, das das Theme inzwischen ersetzt hat: Der Warenkorb
       wird nach Aenderungen neu gerendert. */
    zeigeGeschenke(t);
    alle('[data-mhmw="phasen"]').forEach(function (c) { zeigePhasen(c, t); });
    alle('[data-mhmw-cd][data-frei]').forEach(function (cd) { zeigeCountdown(cd, t, null); });
    if (wartend && Date.now() - wartend > 8000) { wartend = 0; }
    zeigeStaende();
  }

  function starteUhr() {
    if (uhr) { return; }
    uhr = win.setInterval(function () { if (!doc.hidden) { takt(); } }, 1000);
  }

  function zeigeTestHinweis() {
    if (!test.aktiv || doc.getElementById('mhmw-test')) { return; }
    var d = new Date(jetzt() + berlinVersatzMin(jetzt()) * 60000);
    var text = 'MagicWeeks-Test: ' + zwei(d.getUTCDate()) + '.' + zwei(d.getUTCMonth() + 1) + '.' + d.getUTCFullYear() + ' ' +
      zwei(d.getUTCHours()) + ':' + zwei(d.getUTCMinutes()) + (test.korb != null ? ' · Warenwert ' + geld(test.korb, konfig.w) : '');
    var box = doc.createElement('a');
    box.id = 'mhmw-test';
    box.className = 'wg-notranslate';
    box.setAttribute('data-wg-notranslate', '');
    box.href = win.location.pathname + '?mw_now=off';
    box.textContent = text + ' · beenden';
    box.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483000;background:#1E3119;color:#CDE633;font:700 12px/1.3 Lato,Arial,sans-serif;padding:7px 10px;border-radius:6px;text-decoration:none;box-shadow:0 2px 10px rgba(0,0,0,.25)';
    doc.body.appendChild(box);
  }

  function init() {
    if (!doc) { return; }
    ladeKonfig();
    ladeTest();   /* nach der Konfiguration: Sie sagt, ob die Seite aus einer Theme-Vorschau stammt */
    /* servergerenderter Warenwert als Ausgangsstand (Warenkorbseite, Produktseite) */
    var quelle = doc.querySelector('[data-mhmw="stand"][data-wert]');
    if (quelle && !korb.bekannt) {
      korb.wert = parseInt(quelle.getAttribute('data-wert'), 10) || 0;
      korb.wert2 = quelle.hasAttribute('data-wert2') ? (parseInt(quelle.getAttribute('data-wert2'), 10) || 0) : korb.wert;
      korb.artikel = parseInt(quelle.getAttribute('data-artikel'), 10) || 0;
    }
    takt();
    zeigeTestHinweis();
    starteUhr();
    /* Warenkorbseite: einmal den echten Warenkorb holen, damit teure Geschenkzeilen sofort verschwinden */
    if (aufKorbseite()) { holeKorb(true); }
  }

  function start() {
    if (!doc) { return; }
    var html = doc.documentElement;
    function ausEvent(e) {
      if (e && e.detail && e.detail.cart && e.detail.cart.items) { nimmKorb(e.detail.cart); } else { planeAbruf(); }
    }
    html.addEventListener('cart:updated', ausEvent);
    html.addEventListener('cart:refresh', ausEvent);
    /* einzelne Bausteine senden das Event direkt an document statt an <html> */
    doc.addEventListener('cart:updated', function (e) { if (e.target === doc) { ausEvent(e); } });
    doc.addEventListener('cart:refresh', function (e) { if (e.target === doc) { ausEvent(e); } });
    doc.addEventListener('variant:changed', function (e) {
      var v = e && e.detail && e.detail.variant;
      if (!v || typeof v.price !== 'number') { return; }
      /* Variantenwechsel eines ANDEREN Produkts (Quick-Buy in Empfehlungen) geht die Box dieser Seite nichts an */
      if (e.target && e.target.closest && e.target.closest('quick-buy-drawer, quick-buy-popover, .quick-buy-product')) { return; }
      alle('[data-mhmw="stand"][data-preis]').forEach(function (el) {
        if (el.getAttribute('data-kontext') !== 'warenkorb') { el.setAttribute('data-preis', String(v.price)); }
      });
      zeigeStaende();
    });
    doc.addEventListener('click', function (e) {
      /* "Hier bleiben": geplante Weiterleitung der Landingpage abbrechen */
      var bleiben = e.target && e.target.closest ? e.target.closest('[data-mhmw-bleiben]') : null;
      if (bleiben) {
        if (weiterUhr) { win.clearTimeout(weiterUhr); weiterUhr = null; }
        weiterGeplant = true;
        setzeHidden(bleiben.closest('[data-mhmw-weiter-hinweis]'), true);
        return;
      }
      var wahl2 = e.target && e.target.closest ? e.target.closest('[data-mhmw-wahl2]') : null;
      if (wahl2) { e.preventDefault(); waehleGeschenk2(wahl2); return; }
      var wahl = e.target && e.target.closest ? e.target.closest('[data-mhmw-wahl]') : null;
      if (wahl) { e.preventDefault(); waehleGeschenk(wahl); return; }
      var ziel = e.target && e.target.closest ? e.target.closest('#AddToCart, #StickyAddToCart') : null;
      if (ziel && doc.querySelector('[data-mhmw="stand"][data-kontext="modal"]')) { wartend = Date.now(); zeigeStaende(); }
    }, true);
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) { takt(); } });
    win.addEventListener('pageshow', function (e) { if (e && e.persisted) { takt(); } });
    /* Theme-Editor: Sektion neu geladen oder Phasen-Block angeklickt */
    doc.addEventListener('shopify:section:load', function () { init(); });
    doc.addEventListener('shopify:block:select', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-mhmw-b]') : null;
      if (b) { erzwungen = b; takt(); }
    });
    doc.addEventListener('shopify:block:deselect', function () { if (erzwungen) { erzwungen = null; takt(); } });
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', init); } else { init(); }
    /* Nur falls das Theme keinen Warenkorb meldet und ein Baustein ihn braucht */
    win.setTimeout(function () {
      if (!korb.bekannt && doc.querySelector('[data-mhmw="stand"]:not([data-kontext="warenkorb"])') && aktionLaeuft(konfig, jetzt())) { holeKorb(); }
    }, 3000);
  }

  var api = {
    __geladen: true,
    version: '2026.8',
    /* reine Funktionen (auch in tests/ genutzt) */
    zeit: zeit,
    berlinVersatzMin: berlinVersatzMin,
    imFenster: imFenster,
    restTeile: restTeile,
    geld: geld,
    istGeschenk: istGeschenk,
    teureGeschenke: teureGeschenke,
    geschenkRegel: geschenkRegel,
    warenwert: warenwert,
    leseKonfig: leseKonfig,
    geschenkNr: geschenkNr,
    aktionLaeuft: aktionLaeuft,
    stufe2Laeuft: stufe2Laeuft,
    stand: stand,
    zustand: zustand,
    geschenkDabei: geschenkDabei,
    textZustand: textZustand,
    zustand2: zustand2,
    ausnahmen: ausnahmen,
    istS2Familie: istS2Familie,
    vorschlagPasst: vorschlagPasst,
    parameter: parameter,
    testErlaubt: testErlaubt,
    testAusParametern: testAusParametern,
    versatzAus: versatzAus,
    wahlWeg: wahlWeg,
    andererRabatt: andererRabatt,
    /* Browser */
    jetzt: jetzt,
    init: init,
    aktualisiere: function () { takt(); },
    waehleGeschenk: function () { return waehleGeschenk(null); },
    waehleGeschenk2: function () { return waehleGeschenk2(null); },
    konfig: function () { return konfig; },
    korb: function () { return { bekannt: korb.bekannt, wert: korb.wert, wert2: korb.wert2, artikel: korb.artikel, geschenke: korb.geschenke, geschenke1: korb.geschenke1, geschenke2: korb.geschenke2 }; }
  };

  if (typeof module === 'object' && module.exports) { module.exports = api; }
  if (win) { win.MHMagicWeeks = api; }
  if (doc) { start(); }
})(typeof window !== 'undefined' ? window : null);